export default "__VITE_ASSET__CnSSduV9__"